class PageLoader {
  constructor() {
    this.loaderElement = document.getElementById("page-loader");
    this.init();
  }

  init() {
    window.addEventListener("load", () => {
      if (this.loaderElement) {
        this.loaderElement.style.opacity = 0;
        setTimeout(() => {
          this.loaderElement.style.display = "none";
        }, 500);
      }
    });
  }
}

export default PageLoader;
